import React, { PropsWithChildren } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

// Mesmo padrão dos demais fullscreens do app (ex.: FullscreenChart, no mesmo
// diretório): overlay fixo girado para paisagem. A diferença é o
// `overflow: auto`, porque tabela não cabe inteira.
export default function FullscreenTable({
  open,
  dismiss,
  children,
}: PropsWithChildren<{ open: boolean; dismiss: () => void }>) {
  if (!open) return null;

  return (
    <div className="mobile-fullscreen-table-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="mobile-fullscreen-table-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="mobile-fullscreen-table-rotate">
        <div className="mobile-fullscreen-table-content">
          {children}
        </div>
      </div>
      <span className="mobile-fullscreen-table-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
